/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line



  function injectShadowCSS() {
    var host = document.querySelector('#reconvert-slot-7');
    if (!host || !host.shadowRoot) return false;

    var style = document.createElement('style');
   style.textContent = `
  * { font-family: 'Overused Grotesk' !important; }
  .quantity_text_container label { display: none; }
  .heading_font * { font-family: 'Loew' !important; text-transform: uppercase !important; }

  .select_input_wrapper {
    border: 1px solid #dddddd !important;
    background: #ffffff !important;
    border-radius: 99px !important;
  }

  .selectVariantStyle {
    background: transparent !important;
    border: none !important;
    appearance: none !important;
    -webkit-appearance: none !important;
  }

  .section_content .select_input_lable {
    background: #ffffff !important;
    color: #212121 !important;
    font-size: 0.75rem !important;
    padding: 0 0.5em !important;
    left: 15px !important;
    height: 7px !important;
  }

  #checkout_btn {
    background-image: none !important;
    background-color: #ffffff !important;
    border-color: #cb694c !important;
    color: #cb694c !important;
  }

  .quantity_selector_style {
    border-color: #dddddd !important;
    background: #ffffff !important;
    border-radius: 99px !important;
  }

  [class*="flex-col"][class*="w-[calc"] {
    align-items: center;
  }

  [class*="flex"][class*="gap-[14px]"][class*="max-w-[70%]"] {
    align-items: center;
  }

  /* NIEUW: buitenste rij (titel-blok + prijs-blok) verticaal centreren */
  [class*="flex"][class*="w-full"][class*="justify-between"][class*="gap-2"] {
    align-items: center;
  }

  /* NIEUW: prijs-blok zelf centreren i.p.v. items-start */
  [class*="items-start"][class*="h-full"][class*="w-full"] {
    align-items: center !important;
  }

  [class*="items-start"][class*="h-full"][class*="w-full"] > div {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
  }
`;
    host.shadowRoot.appendChild(style);
    return true;
  }

  var tries = 0;
  var interval = setInterval(function () {
    tries++;
    if (injectShadowCSS() || tries > 40) clearInterval(interval);
  }, 250);

  function injectCartDrawerShadowCSS() {
    var host = document.querySelector('#reconvert-slot-cartDrawer-5');
    if (!host || !host.shadowRoot) return false;

    var style = document.createElement('style');
    style.textContent = `
  * { font-family: 'Overused Grotesk' !important; }
`;
    host.shadowRoot.appendChild(style);
    return true;
  }

  var cartDrawerTries = 0;
  var cartDrawerInterval = setInterval(function () {
    cartDrawerTries++;
    if (injectCartDrawerShadowCSS() || cartDrawerTries > 40) clearInterval(cartDrawerInterval);
  }, 250);

  // Bugfix: the theme's <collapsible-elements> component strips the "open"
  // attribute from every accordion on load (its responsive toggle() resets
  // state for desktop/mobile visibility), which breaks the "Open by default"
  // section setting. Re-open anything marked data-default-open after that
  // initial reset has run.
  function forceDefaultOpenAccordions() {
    document.querySelectorAll('collapsible-elements').forEach(function (wrapper) {
      wrapper.querySelectorAll('[data-collapsible][data-default-open="true"]').forEach(function (collapsible) {
        if (!collapsible.hasAttribute('open') && typeof wrapper.open === 'function') {
          wrapper.open(collapsible);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceDefaultOpenAccordions);
  } else {
    forceDefaultOpenAccordions();
  }


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
